var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAddLiquidity(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 13,
    height: 13,
    viewBox: "0 0 13 13",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_71089",
    "data-name": "Path 71089",
    d: "M22.535,16.035H17.988V11.488a.977.977,0,0,0-1.953,0v4.547H11.488a.935.935,0,0,0-.977.977.945.945,0,0,0,.977.977h4.547v4.547a.946.946,0,0,0,.977.977.972.972,0,0,0,.977-.977V17.988h4.547a.977.977,0,1,0,0-1.953Z",
    transform: "translate(-10.512 -10.512)",
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddLiquidity);
export default __webpack_public_path__ + "static/media/add_liquidity.617d46fca89f27a460fae5eb1e5aa9c3.svg";
export { ForwardRef as ReactComponent };